<template>
  <label
    v-for="option in options"
    :key="option.id"
    class="input-radio"
  >
    <input
      class="input-radio__input"
      type="radio"
      :name="name"
      :value="option.value"
      :checked="option.value === value"
      @change="changeHandler"
    />
    <span>{{ option.name }}</span>
  </label>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: null,
    },
  },
  emits: ['change'],
  setup(props, context) {
    const changeHandler = function (e) {
      context.emit('change', {
        type: props.name,
        value: e.target.value,
      });
    };

    return {
      changeHandler,
    };
  },
};
</script>

<style lang="scss">
.input-radio {
  $this: 'input-radio';
  font-size: 14px;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  &__input {
    margin-right: 8px;
  }
}
</style>
